import { IContribuinteIndividual, IContribuinteIndividualForm } from './model/contribuintes-individuais.model';
import { ConfiguracoesService } from '../../configuracoes.service';

export class MeurhContribuintesIndividuaisController {
    static $inject = [
        '$scope',
        '$rootScope',
        'ConfiguracoesService'
    ];

    public entity: IContribuinteIndividualForm;
    public form: angular.IFormController;
    public loading = false;


    public config: {
        chave: string,
        sistema: string,
        valor?: IContribuinteIndividual
    };
    public busy: boolean = false;
    public onSubmit: Function;

    constructor(
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & { session: any },
        public ConfiguracoesService: ConfiguracoesService
    ) {
        this.loading = true;
        ConfiguracoesService.getConfiguracaoJson(
            'PARAMETROS_CONTRATACAO_AUTONOMOS',
            this.$rootScope.session.entities.empresa.empresa
        ).then(response => {
            this.entity = response;
        })
        .finally(() => this.loading = false);
    }

    refreshNivelCargo() {
        this.$rootScope.$broadcast('nivelcargo_refresh', this.setNivelCargoConstructor());
        this.entity.nivelcargo = undefined;
    }

    setNivelCargoConstructor() {
        return this.entity?.cargo?.cargo ? { cargo: this.entity.cargo.cargo } : {};
    }

    submit() {
        this.form.$submitted = true;

        if (this.form.$invalid) {
            return;
        }

        this.config.valor = this.formatData();
        this.onSubmit();
    }

    formatData(): IContribuinteIndividual {
        return {
            cargo: this.entity.cargo!.cargo,
            nivelcargo: this.entity.nivelcargo!.nivelcargo,
            departamentopadrao: this.entity.departamentopadrao || false,
            departamento: this.entity.departamento?.departamento,
            quantidadediasmes: parseInt(this.entity.quantidadediasmes, 10),
            quantidadehorasmes: parseFloat(
                String(this.entity.quantidadehorasmes).replace(',', '.')
            ),
            percentualiss: this.entity.percentualiss,
            percentualinssreducao: this.entity.percentualinssreducao,
            percentualirrfreducao: this.entity.percentualirrfreducao
        };
    }
}
